export default [
  {
    path: "/basicdata/ldagent",
    name: "LDAgentinfo",
    component: () => import("@/views/pages/basicdata/ldagantdata/ldagent.vue"),
    props: true,

    meta: {
      pageTitle: "代書資料維護",
      breadcrumb: [
        {
          text: "基本資料維護",
          active: true,
        },
      ],
    },
  },
  {
    path: "/basicdata/broker",
    name: "Brokerinfo",
    component: () => import("@/views/pages/basicdata/brokerdata/broker.vue"),
    props: true,

    meta: {
      pageTitle: "仲介商資料維護",
      breadcrumb: [
        {
          text: "基本資料維護",
          active: true,
        },
      ],
    },
  },
  {
    path: "/basicdata/shareparameter",
    name: "Shareparameter",
    component: () =>
      import("@/views/pages/basicdata/shareparameterdata/shareparameter.vue"),
    props: true,

    meta: {
      pageTitle: "共用參數維護",
      breadcrumb: [
        {
          text: "基本資料維護",
          active: true,
        },
      ],
    },
  },
  {
    path: "/basicdata/bank",
    name: "Bankinfo",
    component: () => import("@/views/pages/basicdata/bankdata/bank.vue"),
    props: true,

    meta: {
      pageTitle: "銀行資料維護",
      breadcrumb: [
        {
          text: "基本資料維護",
          active: true,
        },
      ],
    },
  },
  {
    path: "/basicdata/brand",
    name: "Brandinfo",
    component: () => import("@/views/pages/basicdata/branddata/brand.vue"),
    props: true,

    meta: {
      pageTitle: "品牌資料維護",
      breadcrumb: [
        {
          text: "基本資料維護",
          active: true,
        },
      ],
    },
  },
  {
    path: "/basicdata/CBmaintain",
    name: "CBmaintain",
    component: () =>
      import("@/views/pages/basicdata/CBmaintaindata/CBmaintain.vue"),
    props: true,

    meta: {
      pageTitle: "實際承辦/業務維護",
      breadcrumb: [
        {
          text: "基本資料維護",
          active: true,
        },
      ],
    },
  },
  {
    path: "/basicdata/RAsetting",
    name: "RAsetting",
    component: () =>
      import("@/views/pages/basicdata/RAsettingdata/RAsetting.vue"),
    props: true,

    meta: {
      pageTitle: "區域專戶設定",
      breadcrumb: [
        {
          text: "基本資料維護",
          active: true,
        },
      ],
    },
  },
  {
    path: "/basicdata/ADmaintain",
    name: "ADmaintain",
    component: () =>
      import("@/views/pages/basicdata/ADmaintaindata/ADmaintain.vue"),
    props: true,

    meta: {
      pageTitle: "行政區資料維護",
      breadcrumb: [
        {
          text: "基本資料維護",
          active: true,
        },
      ],
    },
  },
  {
    path: "/basicdata/LLmaintain",
    name: "LLmaintain",
    component: () =>
      import("@/views/pages/basicdata/LLmaintaindata/LLmaintain.vue"),
    props: true,

    meta: {
      pageTitle: "土地地段維護",
      breadcrumb: [
        {
          text: "基本資料維護",
          active: true,
        },
      ],
    },
  },
  {
    path: "/basicdata/AreaSetting",
    name: "AreaSetting",
    component: () =>
      import("@/views/pages/basicdata/AreaSetting/AreaSetting.vue"),
    props: true,

    meta: {
      pageTitle: "仲介/代書區域設定",
      breadcrumb: [
        {
          text: "基本資料維護",
          active: true,
        },
      ],
    },
  },
  {
    path: "/basicdata/Performanceinfo",
    name: "Performanceinfo",
    component: () =>
      import("@/views/pages/basicdata/Performanceinfodata/Performanceinfo.vue"),
    props: true,

    meta: {
      pageTitle: "績效部門資料維護",
      breadcrumb: [
        {
          text: "基本資料維護",
          active: true,
        },
      ],
    },
  },
  {
    path: "/basicdata/Systemsetting",
    name: "Systemsetting",
    component: () =>
      import("@/views/pages/basicdata/Systemsettingdata/Systemsetting.vue"),
    props: true,

    meta: {
      pageTitle: "仲介/代書體系設定",
      breadcrumb: [
        {
          text: "基本資料維護",
          active: true,
        },
      ],
    },
  },
  {
    path: "/basicdata/Brandsystem",
    name: "Brandsystem",
    component: () =>
      import("@/views/pages/basicdata/Brandsystemdata/Brandsystem.vue"),
    props: true,

    meta: {
      pageTitle: "品牌體系設定",
      breadcrumb: [
        {
          text: "基本資料維護",
          active: true,
        },
      ],
    },
  },
  {
    path: "/basicdata/Performancearea",
    name: "Performancearea",
    component: () =>
      import("@/views/pages/basicdata/Performanceareadata/Performancearea.vue"),
    props: true,

    meta: {
      pageTitle: "績效部門區域資料維護",
      breadcrumb: [
        {
          text: "基本資料維護",
          active: true,
        },
      ],
    },
  },
  {
    path: "/basicdata/Brandreturn",
    name: "Brandreturn",
    component: () =>
      import("@/views/pages/basicdata/Brandreturndata/Brandreturn.vue"),
    props: true,

    meta: {
      pageTitle: "品牌回報代書名稱註記維護",
      breadcrumb: [
        {
          text: "基本資料維護",
          active: true,
        },
      ],
    },
  },
];
